import { SelectTable } from "_components/Abstractions/SelectTable";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { ExternalWeighingContractorTable } from "./ExternalWeighingContractorTable";
import { ordersActions } from "../../../../_store/order.slice";

export function ExternalWeighingContractorSelect({ onSelect, overrideLabel }) {
  const [show, setShow] = useState(false);
  const [items, setItems] = useState([]);
  const dispatch = useDispatch();

  const onSearchChange = async (searchQuery) => {
    setItems({ loading: true });
    const { payload } = await dispatch(ordersActions.searchExternalWeighingContractors({ searchQuery }));
    setItems(payload);
  };

  const onSelectItem = (item) => {
    onSelect(item);
    setShow(false);
  };

  const table = <ExternalWeighingContractorTable
    items={items}
    onSelect={onSelectItem}
  />;

  return (
    <>
      <SelectTable
        table={table}
        label={overrideLabel ?? "Powiąż z programem wagowym"}
        onSearchChange={onSearchChange}
        show={show}
        setShow={setShow}
      />
    </>
  );
}
